import {ref} from 'vue'
import Swal from 'sweetalert2'
import genericAPI from '@/api/api'
import {isValidJson} from "@/services/utility-service";

export function useAdminHandler() {
    const handlingInProgress = ref(false)
    /**
     * Handle the AdminCron
     * @param type
     */
    const handleCron = async (type: 'users' | 'events' | 'assignments') => {
        try {
            handlingInProgress.value = true
            const result = await genericAPI.deleteDocument("admin/cron/", type)
            console.log(result)
            Swal.fire('Deletion of ' + type, `The deletion of ${type} has been successful and #${result.deletedCount} items were deleted.`,'success' )
        } catch (err) {
            console.error(err)
            Swal.fire('Error', 'An error occurred while deletion of ' + type, 'error')
        } finally {
            handlingInProgress.value = false
        }
    }

    const confirmCron = (type: 'users' | 'events' | 'assignments') => {
        Swal.fire({
            title: 'Start cronjob?',
            text: 'Are you sure you want to start delete ' + type + '?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete',
            cancelButtonText: 'Cancel'
        }).then((result) => {
            if (result.isConfirmed) {
                return handleCron(type)
            }
        })
    }

    const confirmReset = () => {
        Swal.fire({
            title: 'Reset DB?',
            text: 'Are you sure you want to reset the DB?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, reset',
            cancelButtonText: 'Cancel'
        }).then((result) => {
            if (result.isConfirmed) {
                return handleReset()
            }
        })
    }

    const handleReset = async () => {
        try {
            handlingInProgress.value = true
            const result = await genericAPI.postDocument("admin/tools/resetDB", {})
            console.log(result)
            Swal.fire(
                'DB Reset',
                `The reset of DB has been successful with this result:<br><br> ${JSON.stringify(result, 2)}.`,
                'success'
            )
        } catch (err) {
            console.error(err)
            Swal.fire('Error', 'An error occurred while resetting DB', 'error')
        } finally {
            handlingInProgress.value = false
        }
    }

    const confirmPush = () => {
        Swal.fire({
            title: 'Send push?',
            text: 'Are you sure you want to send push?',
            icon: 'question',
            input: "textarea",
            inputLabel: "Message",
            inputPlaceholder: "{\n\"title\":\"heyho\",\n\"body\": \"New update!\", \n\"icon\": \"/icon-192.png\"\n}",
            inputAttributes: {
                "aria-label": "Type your message here"
            },
            showCancelButton: true,
            inputValidator: (value) => {
                if (!value) {
                    return "You need to write something!";
                }
                if(!isValidJson(value)) {
                    return "The input is not a valid JSON object.";
                }
            },
            confirmButtonText: 'Yes, send',
            cancelButtonText: 'Cancel'
        }).then((result) => {
            if (result.isConfirmed) {
                const data = JSON.parse(result.value);
                return handlePush(data)
            }
        })
    }
    const handlePush = async (data: object) => {
        try {
            handlingInProgress.value = true
            const result = await genericAPI.postDocument("admin/tools/sendNotifications", data)
            Swal.fire(
                'Push Notification',
                `The push notifications are sent:<br><br> ${JSON.stringify(result, 2)}.`,
                'success'
            )
        } catch (err) {
            console.error(err)
            Swal.fire('Error', 'An error occurred while sending notifications', 'error')
        } finally {
            handlingInProgress.value = false
        }
    }


    return {
        handleCron,
        handleReset,
        confirmReset,
        confirmCron,
        confirmPush,
        handlingInProgress
    }
}
